"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _matrixJsSdk = require("matrix-js-sdk");

var _matrixJsSdk2 = _interopRequireDefault(_matrixJsSdk);

var _MatrixClientPeg = require("../../MatrixClientPeg");

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

var _index = require("../../index");

var _index2 = _interopRequireDefault(_index);

var _Modal = require("../../Modal");

var _Modal2 = _interopRequireDefault(_Modal);

var _languageHandler = require("../../languageHandler");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserView = function (_React$Component) {
    (0, _inherits3.default)(UserView, _React$Component);
    (0, _createClass3.default)(UserView, null, [{
        key: "propTypes",
        get: function get() {
            return {
                userId: _propTypes2.default.string
            };
        }
    }]);

    function UserView(props) {
        (0, _classCallCheck3.default)(this, UserView);

        var _this = (0, _possibleConstructorReturn3.default)(this, (UserView.__proto__ || (0, _getPrototypeOf2.default)(UserView)).call(this, props));

        _this.state = {};
        return _this;
    }

    (0, _createClass3.default)(UserView, [{
        key: "componentWillMount",
        value: function componentWillMount() {
            if (this.props.userId) {
                this._loadProfileInfo();
            }
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
            if (prevProps.userId !== this.props.userId) {
                this._loadProfileInfo();
            }
        }
    }, {
        key: "_loadProfileInfo",
        value: async function _loadProfileInfo() {
            var cli = _MatrixClientPeg2.default.get();
            this.setState({ loading: true });
            var profileInfo = void 0;
            try {
                profileInfo = await cli.getProfileInfo(this.props.userId);
            } catch (err) {
                var ErrorDialog = _index2.default.getComponent('dialogs.ErrorDialog');
                _Modal2.default.createTrackedDialog((0, _languageHandler._t)('Could not load user profile'), '', ErrorDialog, {
                    title: (0, _languageHandler._t)('Could not load user profile'),
                    description: err && err.message ? err.message : (0, _languageHandler._t)("Operation failed")
                });
                this.setState({ loading: false });
                return;
            }
            var fakeEvent = new _matrixJsSdk2.default.MatrixEvent({ type: "m.room.member", content: profileInfo });
            var member = new _matrixJsSdk2.default.RoomMember(null, this.props.userId);
            member.setMembershipEvent(fakeEvent);
            this.setState({ member: member, loading: false });
        }
    }, {
        key: "render",
        value: function render() {
            if (this.state.loading) {
                var Spinner = _index2.default.getComponent("elements.Spinner");
                return _react2.default.createElement(Spinner, null);
            } else if (this.state.member) {
                var RightPanel = _index2.default.getComponent('structures.RightPanel');
                var MainSplit = _index2.default.getComponent('structures.MainSplit');
                var panel = _react2.default.createElement(RightPanel, { user: this.state.member });
                return _react2.default.createElement(
                    MainSplit,
                    { panel: panel },
                    _react2.default.createElement("div", { style: { flex: "1" } })
                );
            } else {
                return _react2.default.createElement("div", null);
            }
        }
    }]);
    return UserView;
}(_react2.default.Component); /*
                              Copyright 2019 New Vector Ltd
                              Copyright 2019 Michael Telatynski <7t3chguy@gmail.com>
                              
                              Licensed under the Apache License, Version 2.0 (the "License");
                              you may not use this file except in compliance with the License.
                              You may obtain a copy of the License at
                              
                                  http://www.apache.org/licenses/LICENSE-2.0
                              
                              Unless required by applicable law or agreed to in writing, software
                              distributed under the License is distributed on an "AS IS" BASIS,
                              WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                              See the License for the specific language governing permissions and
                              limitations under the License.
                              */

exports.default = UserView;
module.exports = exports["default"];
//# sourceMappingURL=UserView.js.map